<template>
  <div class="c-app">
    <TheSidebar/>
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <div v-if="$store.state.impersonatedUser">
              <CAlert class="text-center">
                Você está simulando uma sessão com o usuário <b>{{ $root.$store.state.impersonatedUser }}</b>.
                <a href="#" @click.prevent="stopImpersonating">Cancelar simulação</a>
              </CAlert>
            </div>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter/>
    </CWrapper>

    <Modal/>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import Modal from '@/components/Modal/Index.vue'
import updateNavigationRoutes from './_nav'

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    Modal
  },
  methods: {
    stopImpersonating: function() {
      this.$store.commit('setImpersonatedUser', null)
      updateNavigationRoutes()
      this.$router.push('/users')
      location.reload()
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
